import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../components/AdminLayout';
import { UserCog, RefreshCw, Shield, Clock } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const getToken = () => localStorage.getItem('auth_token') || '';

export default function AdminUsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/admin/users`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      const data = await res.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch {
      toast.error('Failed to load users');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const ROLE_COLORS = {
    admin: { bg: 'rgba(8,29,48,.1)', color: '#081D30' },
    editor: { bg: 'rgba(0,140,134,.1)', color: '#008C86' },
    viewer: { bg: 'rgba(107,114,128,.1)', color: '#6B7280' },
  };

  return (
    <AdminLayout title="System" breadcrumb="Users / Staff">
      <div style={{ maxWidth: 800 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <div>
            <h1 style={{ fontFamily: "'Inter Tight', sans-serif", fontSize: 20, fontWeight: 800, color: '#07121f', letterSpacing: '-.05em', margin: '0 0 4px' }}>
              Users / Staff
            </h1>
            <p style={{ fontSize: 13, color: 'var(--op-muted)', margin: 0 }}>{users.length} user{users.length !== 1 ? 's' : ''}</p>
          </div>
          <button onClick={load} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '8px 14px', background: '#fff', border: '1px solid rgba(221,212,197,0.7)', borderRadius: 8, fontSize: 12, fontWeight: 600, color: 'var(--op-muted)', cursor: 'pointer' }}>
            <RefreshCw size={12} /> Refresh
          </button>
        </div>

        <div style={{ background: '#fff', border: '1px solid rgba(221,212,197,0.7)', borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '48px', color: 'var(--op-muted)' }}>Loading…</div>
          ) : users.map((u, i) => {
            const roleStyle = ROLE_COLORS[u.role] || ROLE_COLORS.viewer;
            return (
              <div key={u.id || i} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 18px', borderBottom: i < users.length - 1 ? '1px solid rgba(221,212,197,0.4)' : 'none' }}>
                <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#081D30', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
                  {(u.name || u.email || '?')[0].toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#07121f' }}>{u.name || '—'}</div>
                  <div style={{ fontSize: 12, color: 'var(--op-muted)' }}>{u.email}</div>
                </div>
                <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 9px', borderRadius: 20, background: roleStyle.bg, color: roleStyle.color, textTransform: 'uppercase', letterSpacing: '.06em', display: 'flex', alignItems: 'center', gap: 4 }}>
                  <Shield size={9} /> {u.role}
                </span>
                {u.created_at && (
                  <div style={{ fontSize: 11, color: 'var(--op-muted)', display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                    <Clock size={10} /> {new Date(u.created_at).toLocaleDateString()}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div style={{ background: '#FFF8EC', border: '1px solid rgba(217,162,69,0.3)', borderRadius: 10, padding: '12px 16px', fontSize: 12, color: '#92400E' }}>
          <strong>Note:</strong> User creation and role management is handled via the admin seeding script. Contact your platform admin to add new staff members.
        </div>
      </div>
    </AdminLayout>
  );
}
